<p-accordion [multiple]="true" class="taly-accordion">
    <p-accordionTab 
        *ngFor="let item of items; 
        let first = first; 
        let last = last; 
        let i = index" 
        [class.isFirst]="first" 
        [class.isLast]="last"
        (click)="toggleActive(i)"> 
        
        <ng-template pTemplate="header">
            <div class="flex align-items-center">
                <span class="vertical-align-middle p-accordion-title" [class.active]="isActive(i)"> 
                    {{ textDirection == 'rtl' ? item.itemTitleAr : item.itemTitleEn }} 
                </span>
                <i class="pi" [ngClass]="{ 'pi-plus': !isActive(i), 'pi-minus': isActive(i) }"></i>
            </div>
        </ng-template>

        <ng-template pTemplate="content">
            <p class="m-0 p-accordion-desc" [class.active]="isActive(i)">
                {{ textDirection == 'rtl' ? item.descriptionAr : item.descriptionEn }} 
            </p>
        </ng-template>
        
    </p-accordionTab> 
</p-accordion>
